import store from '@/core/common/services/vuex-store';

function normalizeCountryName(name) {
  return String(name)
    .toLowerCase()
    .replace(/[\s\-.,()']/g, '');
}

let letzteQuelle = null;
let cache = { nameByCode: {}, codeByNormalizedName: {} };

function laenderMaps() {
  const quelle = store.state.laender?.laender || [];
  if (quelle !== letzteQuelle) {
    letzteQuelle = quelle;
    cache = quelle.reduce(
      (acc, { countryIso3166, landname }) => {
        acc.nameByCode[countryIso3166] = landname;
        acc.codeByNormalizedName[normalizeCountryName(landname)] = countryIso3166;
        return acc;
      },
      { nameByCode: {}, codeByNormalizedName: {} }
    );
  }
  return cache;
}

// Alle Länder als Objekt ISO-Code -> Landname
function alleLaender() {
  return laenderMaps().nameByCode;
}

// Alle Länder als Optionen für ein Select, alphabetisch nach Landname
function landOptions() {
  return Object.entries(alleLaender())
    .map(([code, name]) => ({ value: code, text: name }))
    .sort((a, b) => a.text.localeCompare(b.text, 'de'));
}

// Ermittelt den ISO-3166-Alpha-2-Code zu einem Reise-Enum-Namen wie "SriLanka" (Ergebnis "LK")
function reiseCountryToIso3166(country) {
  if (!country) {
    return null;
  }
  return laenderMaps().codeByNormalizedName[normalizeCountryName(country)] || null;
}

// Liefert den Landnamen zu einem ISO-Code, bei unbekanntem Code den Code selbst
function germanCountryName(code) {
  return alleLaender()[code] || code;
}

// Liefert den Landnamen zu einem Reise-Enum-Namen, bei unbekanntem Land den Enum-Namen selbst
function reiseCountryName(country) {
  const code = reiseCountryToIso3166(country);
  return (code && alleLaender()[code]) || country;
}

export { alleLaender, landOptions, reiseCountryToIso3166, germanCountryName, reiseCountryName };
